export default "__VITE_ASSET__C2MfuH61__"